import { connect } from 'react-redux'
import { IStoreState } from '../../types/index'
import MakePane from 'src/components/global-settings/MakePane'

const mapStateToProps = (state: IStoreState, ownProps: any): any => {
  return {
    makes: state.vehicleCreateOptions.makes
  }
}

const mapDispatchToProps = (dispatch: any): any => {
  return {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MakePane)



// WEBPACK FOOTER //
// ./src/containers/global-settings/MakePane.ts